/**
* author: duxin
* date: 2020/4/8
* describe: 菜单栏
*/

<template>
	<div class="menu-wrap" @mouseleave="onMouseleave" :class="{ 'scroll-nav': !scrollTop }">
		<template v-for="(menu,index) in menuList">
			<RouterLink
				class="submenu menu-item"
				ref="menu"
				@click.native="onClick(index)"
				:to="menu.path"
				tag="li"
				@mouseleave.native="onMouseout(index)"
				@mouseenter.native="onMouseenter(index)"
			>
				{{menu.title}}
				<ul
					class="drop-menu"
					:class="lang == 'en' ? 'en-width' :''"
					ref="dropMenu"
					v-show="menu.children"
				>
					<template v-if="menu.children">
						<li class="mask-drop"></li>
						<RouterLink
							v-for="child in menu.children"
							:to="child.path"
							@click.native="onClick(index)"
							class="drop-link"
							activeClass="active-link"
							tag="li"
						>{{child.title}}</RouterLink>
					</template>
				</ul>
				<div class="mask" @click.prevent.stop v-if="menu.children"></div>
			</RouterLink>
		</template>
		<span class="line" ref="line"></span>
	</div>
</template>

<script>
export default {
	name: 'kllk-menu',
	props: {
		menus: {
			type: Array,
			default: () => {
				return []
			},
		},
		scrollTop: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			menuList: this.menus,
		}
	},
	created() {
		this.current = { offsetLeft: 0, offsetWidth: 58 }
	},
	watch: {
		$route(v) {
			this.handleRoute()
		},
	},
	computed: {
		lang() {
			return sessionStorage.getItem('language')
		},
	},
	mounted() {
		for (let i = 0; i < this.$refs.menu.length; i++) {
			let el = this.$refs.menu[i].$el
			this.menuList[i].offsetLeft = el.offsetLeft
			this.menuList[i].offsetWidth = el.offsetWidth
			if (this.menuList[i].children) {
				let dropMenuEl = this.$refs.dropMenu[i]
				this.menuList[i].height = dropMenuEl.offsetHeight
				dropMenuEl.style.height = 0
			}
		}
		this.handleRoute()
	},
	methods: {
		handleRoute() {
			if (!this.$route.matched[1]) return;//媒体查询页面没有匹配的path
			let currPath = this.$route.matched[1].path
			let t = this.menuList.find((item) => item.path === currPath)
			if (t) {
				this.$refs.line.style.left = `${t.offsetLeft}px`
				this.$refs.line.style.width = `${t.offsetWidth}px`
				this.current.offsetLeft = t.offsetLeft
				this.current.offsetWidth = t.offsetWidth
			}
		},
		//鼠标浮上
		onMouseenter(index) {
			if (this.menuList[index].children) {
				this.$refs.dropMenu[index].style.height =
					this.menuList[index].height + 'px'
				this.$refs.dropMenu[index].style.visibility = 'visible'
			}
			this.$refs.line.style.left = `${this.menuList[index].offsetLeft}px`
			this.$refs.line.style.width = `${this.menuList[index].offsetWidth}px`
		},
		//鼠标离开单个menu
		onMouseout(index) {
			if (this.menuList[index].children) {
				this.$refs.dropMenu[index].style.height = '0px'
				this.$refs.dropMenu[index].style.visibility = 'hidden'
			}
		},
		//鼠标离开整个menu
		onMouseleave() {
			this.$refs.line.style.left = `${this.current.offsetLeft}px`
			this.$refs.line.style.width = `${this.current.offsetWidth}px`
		},
		//菜单点击
		onClick(index) {
			let menuListElement = this.menuList[index]
			if (menuListElement.call) {
				menuListElement.call()
				return
			}
			this.current.offsetLeft = menuListElement.offsetLeft
			this.current.offsetWidth = menuListElement.offsetWidth

			this.onMouseout(index)
		},
	},
}
</script>

<style lang="less" scoped>
@import '../style/constant.less';
li {
	list-style: none;
}

.submenu {
	position: relative;

	.mask {
		position: absolute;
		top: 0;
		left: 0;
		z-index: 10;
		width: 100%;
		height: 100%;
	}

	.drop-link {
		padding: 10px;
		color: #181818;
		background-color: white;

		&:hover {
			color: #435ba1;
		}
	}

	.drop-menu {
		visibility: hidden;
		display: inline-block;
		transition: height 0.3s;
		overflow: hidden;
		position: absolute;
		top: 52px;
		align-self: flex-end;
		z-index: 100;
		min-width: 150px;
		left: -15px;
		box-shadow: 0 2px 5px -2px #c6c6c6;
		border-radius: 2px;
		padding: 0;

		.mask-drop {
			height: 5px;
		}
	}
	// 英文导航不换行
	.en-width {
		min-width: 180px;
	}
}

.menu-wrap {
	display: flex;
	color: black;
	position: relative;
	height: 100%;
	align-items: center;
	font-size: 16px;

	.menu-item {
		margin: 0 15px;
		cursor: pointer;
		height: 100%;
		display: flex;
		align-items: center;
		color: white;

		&:hover {
			color: white;
			.line {
				display: block;
			}
		}
	}

	.line {
		position: absolute;
		width: 64px;
		height: 3px;
		background-color: white;
		bottom: 0;
		transition: width 0.3s, left 0.3s;
		display: none;
	}
	&:hover {
		.line {
			display: block;
		}
	}
}

.scroll-nav {
	.menu-item {
		color: white;
		&:hover {
			color: white;
		}
	}

	.line {
		background-color: white;
	}
}

.active-link {
	color: @h2-color !important;
}
</style>
